
// https://javascript.info/custom-errors
class BasePrintServiceError extends Error {
    constructor(message) {
        super(message)
        this.name = this.constructor.name
    }
}

export class FailSetPrintedError extends BasePrintServiceError {}
export class FailToPrintError extends BasePrintServiceError {}